// @ts-ignore
import { createClass } from "asteroid";
import Settings from "../settings";

const Asteroid = createClass();
const serverUrl = Settings.meteor_server_url || "";
const hostName = serverUrl.replace(/https?:\/\//, "");
const prefix = serverUrl.match(/https/) ? "wss" : "ws";
export const meteorEndpoint = `${prefix}://${hostName}/websocket`;
export const asteroid = new Asteroid({ endpoint: meteorEndpoint });
